/* eslint-disable array-callback-return */
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useLocation, useNavigate } from "react-router-dom";
import { Breadcrumbs, Box } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SeparatorImage from "./icons/separator.svg";
import { SidebarContext } from "../../../contexts/SidebarContext";
import { FC, useContext } from "react";
import { EntityContext } from "../../../contexts/EntityContext";
import { styled } from "@mui/material/styles";
// type ZsBreadcrumbsProps = { isLastItem: any };
const ZsBreadcrumbs: FC = () => {
  const { routes } = useContext(SidebarContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { entity } = useContext(EntityContext);

  const pathnames = location.pathname.split("/").filter((x) => x);
  // discard parent menu
  const discardedItems = routes?.map((route: any) => {
    if (route?.children) return route?.name?.toUpperCase();
  });
  discardedItems?.push("DASHBOARD");

  const BreadcrumbsWrapper = styled(Box)(() => ({
    h3: {
      cursor: "pointer",
      opacity: 0.8,
      "&:hover": {
        opacity: 1,
      },
    },
  }));

  const Separator = () => {
    return (
      <img src={SeparatorImage} alt="Separator" className="separatorArrow" />
    );
  };

  return (
    <BreadcrumbsWrapper>
      <Breadcrumbs separator={Separator()}>
        {pathnames.length > 0 ? (
          <Link
            className="item"
            color="inherit"
            onClick={() => navigate("/dashboard")}
          >
            <Typography variant="h3">
              <HomeIcon />
            </Typography>
          </Link>
        ) : (
          <Typography variant="h3">
            <HomeIcon />
          </Typography>
        )}

        {pathnames.map((name, index) => {
          if (!discardedItems?.includes(name?.toUpperCase())) {
            const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
            const isLast = index === pathnames.length - 1;
            const isNumeric = /^\d+$/.test(name);
            let convertedCamelCaseName = "";

            let result = name.replace(/([A-Z])/g, " $1");
            // Capitalize the first letter of the resulting string
            convertedCamelCaseName =
              result.charAt(0).toUpperCase() + result.slice(1);

            return isLast ? (
              <Link className="lastItem" color={"inherit"} key={name}>
                <Typography variant="h3">
                  {entity ? entity?.entityName : convertedCamelCaseName}
                </Typography>
              </Link>
            ) : (
              <Link
                variant="h3"
                color={"inherit"}
                className="lastChild"
                onClick={() => navigate(routeTo)}
                key={name}
              >
                <Typography variant="h3" >
                  {isNumeric
                    ? entity.entityName
                    : convertedCamelCaseName.replace(/-/g, " ")}
                </Typography>
              </Link>
            );
          } else {
            return null;
          }
        })}
      </Breadcrumbs>
    </BreadcrumbsWrapper>
  );
};

export default ZsBreadcrumbs;
